module.exports = __webpack_public_path__ + "static/media/wardrober_banner@small.fa60bbc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/wardrober_banner@small.png
// module id = 572
// module chunks = 0